import { render, staticRenderFns } from "./OtherConfig.vue?vue&type=template&id=1eeadc29&"
import script from "./OtherConfig.vue?vue&type=script&lang=js&"
export * from "./OtherConfig.vue?vue&type=script&lang=js&"
import style0 from "./OtherConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports